import React from "react";
import "./styles/review.css"; // eigenes CSS
//@ts-ignore
import { Rating } from "react-simple-star-rating";

function Review( {review} ) {
  return (
    <div>
      <div className="review-card">
        <div className="review-header">
          <strong>{review.name}</strong>
          <Rating
            initialValue={review.rating}
            readonly
            allowFraction
            size={20}
          />
        </div>
        <p className="review-text">{review.text}</p>
      </div>
    </div>
  );
}

export default Review;
